import React, {Component} from 'react'
import AdminTabs from "./admin-tabs/AdminTabs";

import '../../style/AdminDashboard.css'
import '../../style/rtl_css/AdminDashboard.css'
import {history} from "../../utils/history";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import AdminEntryForm from "../../components/admin/AdminEntryForm";
import AdminGenerateReport from "./AdminGenerateReport";
import AdminGenerateRequestReport from "./AdminGenerateRequestReport";
import AdminGenerateRequestHistory from "./AdminGenerateRequestHistory";

class AdminDashboardConComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            low: false,
            medium: false,
            high: false,
            total: false,
            onUpdate: false,
            onError: false,
            isSideBarOpen: false,
            isSideBar2Open: false,
            isSideBar3Open: false,
        }
    }

    componentDidMount = async () => {
        this.setState({total:true})
        history.push({
            pathname: `/dashboard/hcps`,
            state: {
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    async toggle(state) {
        let total,onUpdate,onError = false;
        switch (state) {
            case 'total': {total = true; break;}
            case 'onUpdate': {onUpdate = true; break;}
            case 'onError': {onError = true; break;}
            default:  break;
        }
        this.setState({
            total,onUpdate,onError
        })
    }

    render() {
        let {t}=this.props
        let{isSideBarOpen,isSideBar2Open,isSideBar3Open}=this.state
        return (
            <div className={'sade-admin-dashboard'}>
                <div className={'asaya-info'}>
                    <div className={'asaya-info'}>
                        <div className={'asaya-info-main-container container'}>
                        </div>
                    </div>
                </div>

                <div className={'sade-admin-dashboard container'}>

                    <div  onClick={()=>this.setState({isSideBarOpen:!isSideBarOpen})}
                          className={'sade-admin-dashboard-generateReport'}>{t('hcpLeumitPatientRequests.generateReport')}</div>
                </div>
                <div className={'sade-admin-dashboard container'}>

                    <div  onClick={()=>this.setState({isSideBar2Open:!isSideBar2Open})}
                          className={'sade-admin-dashboard-generateReport'}>{t('hcpLeumitPatientRequests.generateReportPatients')}</div>
                </div>

                <div className={'sade-admin-dashboard container'}>

                    <div  onClick={()=>this.setState({isSideBar3Open:!isSideBar3Open})}
                          className={'sade-admin-dashboard-generateReport'}>{t('hcpLeumitPatientRequests.generateRequestHistory')}</div>
                </div>

                <div className={'sade-admin-dashboard container'}>
                    <AdminTabs toggle={state => this.toggle(state)}/>
                </div>


                {isSideBarOpen && <AdminGenerateReport
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.generateReport')}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}

                {isSideBar2Open && <AdminGenerateRequestReport
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.generateReportPatients')}
                    isSideBarOpen={isSideBar2Open}
                    closeSideBar={() => this.setState({isSideBar2Open: false})}/>}

                {isSideBar3Open && <AdminGenerateRequestHistory
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.generateRequestHistory')}
                    isSideBarOpen={isSideBar3Open}
                    closeSideBar={() => this.setState({isSideBar3Open: false})}/>}
            </div>

        )
    }
}




const AdminDashboard = compose(
    withTranslation(),
    connect(
    )
)(AdminDashboardConComposed);

export default AdminDashboard;
